import { LocalAudioTrack } from 'twilio-video';
import { useCallback } from 'react';
import useIsTrackEnabled from '../useIsTrackEnabled/useIsTrackEnabled';
import useVideoContext from '../useVideoContext/useVideoContext';

export default function useLocalAudioMuteOrUnmute() {
  const { room: {localParticipant},localTracks } = useVideoContext();
  const audioTrack = localTracks.find(track => track.kind === 'audio') as LocalAudioTrack;
  const isEnabled = useIsTrackEnabled(audioTrack);

  const muteUnmuteAudio = useCallback((props: any, status) => {

    if (audioTrack) {
      if(status == true){
        audioTrack.disable();
      } else if (status == false){
        
        if(localParticipant){
          localParticipant.publishTrack(audioTrack);
        } else if(props.room && props.room.activeRoom && props.room.activeRoom.localParticipant){
          props.room.activeRoom.localParticipant.publishTrack(audioTrack);
        }
        audioTrack.enable();
        let callId = props.patient && props.patient.activeCall && props.patient.activeCall.callId

        if(props.patient && props.patient.activeCall && props.patient.activeCall.isMute && props.patient.activeCall.isMute == "true"){
          if(props.muteParticipant){
            props.muteParticipant(false);
          }
        }
      }
    }
  }, [audioTrack]);

  

  return [isEnabled, muteUnmuteAudio] as const;
}
